import { useElement, useListen } from '@atomify/hooks';
import { AREA_SUBSCRIPTION_LOADED_EVENT } from '@features/area-subscription/constants';
import { AreaSubscriptionElement } from '@features/area-subscription/types';
import { loadAreaSubscription } from '@utilities/loaders';

import { nextEvent } from '../next-event';

type AreaSubscriptionLoadedEvent = CustomEvent<{ loaded: boolean }>;

export const useAreaSubscriptionLoader = () => {
    const element = useElement<AreaSubscriptionElement>('bpd-area-subscription', {
        root: document,
    });

    let subscriptionFlowLoaded = false;
    useListen(
        element,
        AREA_SUBSCRIPTION_LOADED_EVENT,
        (e: AreaSubscriptionLoadedEvent) => (subscriptionFlowLoaded = e.detail.loaded),
    );

    const isLoaded = () => subscriptionFlowLoaded || element.current?.loaded;

    const load = async () => {
        if (!element.current) {
            console.warn('Subscription is not available');
            return false;
        }

        if (isLoaded()) return true;

        await loadAreaSubscription();
        const event = await nextEvent<AreaSubscriptionLoadedEvent>(
            element.current,
            AREA_SUBSCRIPTION_LOADED_EVENT,
        );

        return event.detail.loaded;
    };

    return {
        element,
        isLoaded,
        load,
    };
};
